import {Injectable} from '@angular/core';
import {ModuleInterface} from '../shared/ModuleInterface';
import {HttpClient} from '@angular/common/http';
import {LoaderService} from './loader.service';
import {MapperService} from "./mapper.service";
import {Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {Zone} from '../shared/entities/user.entity';

@Injectable()
export class PredictService  {

  public moduleMapper: ModuleInterface;
  public modulePicto: ModuleInterface;
  public moduleIgoLayersBbff: ModuleInterface;

  constructor(
    public httpClient: HttpClient,
    public loaderService: LoaderService,
    public authService: AuthService,
    private mapperService: MapperService
  ) {
    this.moduleMapper = new ModuleInterface('mapper', this.httpClient, this.loaderService, true);
    this.modulePicto = new ModuleInterface('picto', this.httpClient, this.loaderService);
    this.moduleIgoLayersBbff = new ModuleInterface('igo_layers_bff', this.httpClient, this.loaderService);
  }

  getPolygon(code_zone, type_zone): Observable<any> {
    return this.moduleMapper.post(`zone/polygon_from_list`, {list: [{
        type_zone,
        code_zone,
      }]
    });
  }

  getZmi(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zmi/${bbox}`);
  }

  getZms(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zms/${bbox}`);
  }

  getZmff(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zmf/${bbox}`);
  }

  getZmMvt(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zmmvt/${bbox}`);
  }

  getZmTsunami(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zm-tsunami/${bbox}`);
  }

  getZmTmd(bbox): Observable<any> {
    return this.moduleIgoLayersBbff.get(`layer/zm-tmd/${bbox}`);
  }


  getZoneWithFilters(term, filters): Observable<any> {
    return this.moduleMapper.post('zones/search', {search : term, filters})
      .pipe(map((v) => v.list));
  }

  getListPictoInforisque(): Observable<any> {
    return this.modulePicto.get('picto/inforisque/list')
      .pipe(map((v) => v.list));
  }

  getListPictoPlan(): Observable<any> {
    return this.modulePicto.get('picto/plan/list')
      .pipe(map((v) => v.list));
  }

  handleZones(idUser): Observable<any> {
    return new Observable((observer) => {
      if (!idUser) {
        observer.next([]);
        return;
      }

      this.mapperService.getSupervisedZone(idUser).subscribe((res) => {
        if (res.list.length > 0) {
          observer.next(res.list);
        } else {
          observer.next([]);
        }
      }, () => {
        observer.next([]);
      });
    });
  }

  getPolygonUnionFromListZone(listZone: Zone[]): Observable<any> {
    return this.moduleMapper.post('zone/union_polygon_from_list', {list: listZone});
  }
}
